import { useContext } from 'react';
import { useIntl } from 'react-intl';
import { appUserContext } from 'helpers/services';
import { LocalizationIds } from 'helpers/Localizations';
import { PageHeader } from 'components';
import { CustomerTicketsProvider } from './CustomerTicketsContext';
import { Mobile, Desktop } from './components';


let Tickets = () => {
    let { formatMessage } = useIntl();
    let { isMobile } = useContext(appUserContext);

    return (
        <CustomerTicketsProvider>
            <PageHeader pageTitle={formatMessage({ id: LocalizationIds.Tickets })} addNewUrl={"/customer/ticket/addnew"} />
            {isMobile && <Mobile />}
            {isMobile === false && <Desktop />}
        </CustomerTicketsProvider>
    );
}

export default Tickets;